import { schema } from 'normalizr';

const statisticSchema = new schema.Entity(
  'statistic',
  {},
  { idAttribute: 'name' }
);

export default statisticSchema;
